import {themeConfig} from 'constants/theme';

type TreeConfig = {
    color: string;
    className: string;
}

export const MAX_DEPTH = 7;

export const DEFAULT_TREE_CONFIG: TreeConfig = {
    color: themeConfig.colors.black,
    className: ''
};

export const TREE_CONFIG: Record<number, TreeConfig> = {
    0: {
        color: themeConfig.colors.blue,
        className: ''
    },
    1: {
        color: themeConfig.colors.accentCyan,
        className: 'tw-ml-4 md:tw-ml-8'
    },
    2: {
        color: themeConfig.colors.lightGreen,
        className: 'tw-ml-8 md:tw-ml-16'
    },
    3: {
        color: themeConfig.colors.accentViolet,
        className: 'tw-ml-12 md:tw-ml-24'
    },
    4: {
        color: themeConfig.colors.accentSky,
        className: 'tw-ml-16 md:tw-ml-32'
    },
    5: {
        color: themeConfig.colors.darkGreen,
        className: 'tw-ml-20 md:tw-ml-40'
    },
    6: {
        color: themeConfig.colors.lightOrange,
        className: 'tw-ml-24 md:tw-ml-48'
    },
    7: {
        color: themeConfig.colors.black,
        className: 'tw-ml-28 md:tw-ml-56'
    }
};